// extracted by mini-css-extract-plugin
export default {"ldsRoller":"Loading_ldsRoller__gEtw1","animateRoller":"Loading_animateRoller__QbfJN","ldsRollerDark":"Loading_ldsRollerDark__qKOay"};